import { api } from './api-client';

export type TeamRole = 'company_admin' | 'admin' | 'internal' | 'security' | 'resident';
export type StaffPermission =
  | 'can_manage_staff'
  | 'can_manage_units'
  | 'can_manage_residents'
  | 'can_manage_invite_codes'
  | 'can_post_announcements'
  | 'can_manage_facilities'
  | 'can_approve_bookings'
  | 'can_manage_payments'
  | 'can_manage_complaints'
  | 'can_view_emergency';

export const STAFF_PERMISSIONS: { id: StaffPermission; labelKey: string }[] = [
  { id: 'can_manage_staff', labelKey: 'team.perm.staff' },
  { id: 'can_manage_units', labelKey: 'team.perm.units' },
  { id: 'can_manage_residents', labelKey: 'team.perm.residents' },
  { id: 'can_manage_invite_codes', labelKey: 'team.perm.invites' },
  { id: 'can_post_announcements', labelKey: 'team.perm.announcements' },
  { id: 'can_manage_facilities', labelKey: 'team.perm.facilities' },
  { id: 'can_approve_bookings', labelKey: 'team.perm.bookings' },
  { id: 'can_manage_payments', labelKey: 'team.perm.payments' },
  { id: 'can_manage_complaints', labelKey: 'team.perm.complaints' },
  { id: 'can_view_emergency', labelKey: 'team.perm.emergency' },
];

export async function listInvitationUnits(clusterId: string) {
  const { data } = await api.get<{ items: { id: string; label: string; block: string; number: string }[] }>(
    '/admin/team-invitations/units', { params: { cluster_id: clusterId } },
  );
  return data.items;
}

export async function createTeamInvitation(input: {
  developer_id: string; cluster_id: string; cluster_ids?: string[];
  email: string; full_name: string; role: TeamRole;
  permissions?: StaffPermission[]; unit_id?: string;
}) {
  const { data } = await api.post<{ invitation_id: string | null; email: string; role: string; status: string }>(
    '/admin/team-invitations', input,
  );
  return data;
}

export interface TeamMember {
  id: string;
  email: string;
  full_name: string;
  role: 'STAFF' | 'SECURITY' | 'RESIDENT';
  app_role: 'ADMIN' | 'INTERNAL' | 'RESIDENT' | null;
  admin_scope: 'PLATFORM' | 'DEVELOPER' | 'CLUSTER';
  status: 'PENDING' | 'ACTIVE' | 'SUSPENDED';
  cluster_id: string | null;
}

export async function listTeamMembers(clusterId: string): Promise<TeamMember[]> {
  const { data } = await api.get<{ items: TeamMember[] }>('/admin/team-invitations/members', { params: { cluster_id: clusterId } });
  return data.items;
}

export async function removeTeamMember(id: string): Promise<void> {
  await api.delete(`/admin/team-invitations/members/${id}`);
}
